<form>
   <div class="sam-form-row">
      <label>{{ 'brick.brick_definitions.grafana_dashboard_viewer.settings.dashboard' | translate }}</label>
      <kendo-dropdownlist
         class="k-form-field sam-form-control sam-form-control-full-width"
         [value]="(dashboardSettings$ | async).dashboardId"
         [data]="availableDashboards$ | async"
         [valuePrimitive]="true"
         valueField="id"
         textField="name"
         (valueChange)="selectedDashboardChanged($event)"
      >
      </kendo-dropdownlist>
   </div>

   <div class="sam-form-row">
      <label>{{ 'brick.brick_definitions.grafana_dashboard_viewer.settings.agent' | translate }}</label>
      <kendo-dropdownlist
         class="k-form-field sam-form-control sam-form-control-full-width"
         [value]="(dashboardSettings$ | async).agentId"
         [data]="availableAgents$ | async"
         [valuePrimitive]="true"
         valueField="id"
         textField="name"
         (valueChange)="selectedAgentChanged($event)"
      >
      </kendo-dropdownlist>
   </div>

   <div class="sam-form-row">
      <label>{{ 'brick.brick_definitions.grafana_dashboard_viewer.settings.timezone' | translate }}</label>
      <kendo-switch
         [checked]="(dashboardSettings$ | async).useBrowserTimezoneAsTargetTimezone"
         (valueChange)="useBrowserTimezoneAsTargetTimezoneChanged($event)"
      ></kendo-switch>
   </div>
</form>
